import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { passwordMinLength } from '@rp/shared/models';

import { Validation } from './enums';

export const passwordValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = control.value;
  if (!value || value.length < passwordMinLength) {
    return { [Validation.PasswordComplexity]: true };
  }
  const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%&\-_])[ A-Za-z0-9!@#$%&\-_]+$/;

  return regex.test(value) ? null : { passwordComplexity: true };
};
